import { XRInputHelper } from "../babylon/XRInputHelper";
export class ScrollHandler {
    get value() {
        return this._value;
    }
    constructor(meshNames, velocity, callback, useUpdateInterval = true) {
        this._scrollVelocity = 0;
        this._value = 0;
        this._meshNames = meshNames;
        this._velocity = velocity;
        this._callback = callback;
        this._useUpdateInterval = useUpdateInterval;
    }
    addThumbstickAxesChangedListener(isVertical = true) {
        if (this._thumbstickAxesChangedListenerHandler !== undefined)
            return;
        this._thumbstickAxesChangedListenerHandler = XRInputHelper.getInstance()?.addThumbstickAxesChangedListener(this._meshNames, (sender, x, y, _deltaTime) => {
            const v = isVertical ? y : x;
            if (this._meshNames.every(n => n !== sender.name))
                return;
            if (Math.abs(v) < 0.01 || (isVertical && Math.abs(x) > Math.abs(y)) || (!isVertical && Math.abs(y) > Math.abs(x))) {
                this.stopScroll();
            }
            else {
                this._value = v;
                const scrollUpdatePeriod = 50;
                const value = () => {
                    const velocityFactor = this.value * this.value * this.value;
                    this._scrollVelocity = velocityFactor * this._velocity;
                    return this._scrollVelocity * scrollUpdatePeriod / 1000;
                };
                if (this._scrollDrawInterval === undefined) {
                    if (this._useUpdateInterval)
                        this._scrollDrawInterval = setInterval(() => {
                            this._callback(value());
                        }, scrollUpdatePeriod);
                    else {
                        this._callback(value());
                    }
                }
            }
        });
    }
    releaseThumbstickAxesChangedListener() {
        if (this._thumbstickAxesChangedListenerHandler === undefined)
            return;
        XRInputHelper.getInstance()?.removeThumbstickAxesChangedListener(this._thumbstickAxesChangedListenerHandler);
        this._thumbstickAxesChangedListenerHandler = undefined;
    }
    stopScroll() {
        this._scrollVelocity = 0;
        if (this._scrollDrawInterval !== undefined) {
            clearInterval(this._scrollDrawInterval);
            this._scrollDrawInterval = undefined;
        }
    }
}
